module.exports = __webpack_public_path__ + "img/nishma.b265dd23.jpg";